import React from 'react';
import styled from 'styled-components';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';
import LogTimelineEvent, { LogTimelineEventProps } from './LogTimelineEvent';

const StyledDiv = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACERS.small};
`;

export interface LogTimelineProps {
  timelineEvents: LogTimelineEventProps[];
}

const LogTimeline: React.FC<LogTimelineProps & {
  selectedIndex?: number;
  handleClick?: (event: LogTimelineEventProps, index: number) => unknown;
}> = ({ selectedIndex, timelineEvents, handleClick }) => {
  const total = timelineEvents.length;
  return (
    <StyledDiv>
      {timelineEvents.map((event, i) => (
        <LogTimelineEvent
          key={event.id}
          {...event}
          selected={i === selectedIndex}
          isLastEvent={i === total - 1}
          onClick={handleClick ? () => handleClick(event, i) : undefined}
        />
      ))}
    </StyledDiv>
  );
};

export default LogTimeline;
